import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendEmailVerification,
  PhoneAuthProvider,
  RecaptchaVerifier,
  getMultiFactorResolver,
  PhoneMultiFactorGenerator,
  sendPasswordResetEmail,
} from 'firebase/auth';

import { getFunctions, httpsCallable } from 'firebase/functions';

const config = {
  projectId: 'enliv-342806',
  apiKey: 'AIzaSyCWUzeZ7-Xf8fZCWJULHYDbc7poG4F3_ik',
  authDomain: 'enliv-342806.firebaseapp.com',
};

const firebaseApp = initializeApp(config);
const auth = getAuth(firebaseApp);
const functionsInstance = getFunctions(firebaseApp, 'us-east4');

console.log('firebaseApp', functionsInstance);

export {
  auth,
  functionsInstance,
  httpsCallable,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendEmailVerification,
  PhoneAuthProvider,
  RecaptchaVerifier,
  getMultiFactorResolver,
  PhoneMultiFactorGenerator,
  sendPasswordResetEmail,
};
